import React from 'react'
import '../../../base/Theme.css'
import './Progress.css';

const Progress = ({style, progress, max}) => {
    let percent = 0;
    if (progress) {
        percent = 100 - (progress / max * 100);
        if (percent <= 0) percent = 0;
    }

    let barColorStyle = "";
    if (percent > 50) barColorStyle = "ProgressBarGreen";
    else if (percent > 30) barColorStyle = "ProgressBarOrange";
    else if (percent >= 0) barColorStyle = "ProgressBarRed"


    const rootStyle = "ProgressRoot " + style;
    const barStyle = "ProgressBar " + barColorStyle;

    const progressWidthStyle = {width: percent + "%"};
    return (
        <div className={rootStyle}>
            <div className={barStyle} style={progressWidthStyle}/>
        </div>
    );
}

export default Progress;
